import {
  Component,
  Inject,
  AfterViewInit,
  OnInit,
  CUSTOM_ELEMENTS_SCHEMA,
  PLATFORM_ID,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ApiPayloadService } from '../../Services/api-payload-service.service';
import { ApiCallService } from '../../Services/api-call-service.service';
import { CreateUser, Slide } from '../../Interfaces/interfaces';
import { DeviceIdService } from '../../Services/device-id.service';
import {
  CommonModule,
  isPlatformBrowser,
  ViewportScroller,
} from '@angular/common';
import {
  passwordMatchValidator,
  passwordValidator,
} from '../../Services/password-match.service';
import { ToastrService } from 'ngx-toastr';
import { LoaderComponent } from '../../components/loader/loader.component';
import { LoaderService } from '../../Services/loader-service.service';
import {
  faEye,
  faEyeSlash,
  faCheck,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { register } from 'swiper/element/bundle';
import { SignUpPopUpComponent } from './sign-up-pop-up/sign-up-pop-up.component';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from '../../Services/notification.service';
import { CookieService } from 'ngx-cookie-service';
import { MusicService } from '../../Services/music.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-signup',
  standalone: true,
  imports: [
    LoaderComponent,
    ReactiveFormsModule,
    RouterModule,
    CommonModule,
    FontAwesomeModule,
  ],
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SignupComponent implements OnInit, AfterViewInit {
  faBars = faBars;
  signupForm!: FormGroup;
  errorMessage: string | null = null;
  showpassword = false;
  Confirmshowpassword = false;
  showicon = faEye;
  hideicon = faEyeSlash;
  checkIcon = faCheck;
  timesIcon = faTimes;
  isPasswordFocused = false;
  passwordStrength = 0;
  passwordChecks = {
    length: false,
    numbers: false,
    uppercase: false,
    lowercase: false,
    special: false,
  };
  showPasswordErrorsOnSubmit: boolean = false;
  @Input() isPopup = false;
  @Output() closed = new EventEmitter<void>();
  @Output() switchToLogin = new EventEmitter<void>();

  // slides: Slide[] = [
  //   {
  //     id: 2,
  //     src: '/Images/landing_1.png',
  //     heading: 'Spin and Win Big!',
  //     content:
  //       'Take a spin and grab your chance to win exciting prizes instantly!',
  //   },
  //   {
  //     id: 3,
  //     src: '/Images/landing_2.png',
  //     heading: 'Explore Games!',
  //     content:
  //       'Choose from a variety of exciting casino games and start your winning streak today!',
  //   },
  //   {
  //     id: 4,
  //     src: '/Images/landing_3.png',
  //     heading: 'Fast and Secure Transactions!',
  //     content:
  //       'Deposit and withdraw your funds with ease, ensuring a seamless gaming experience!',
  //   },
  // ];

  window: Window | null = null;

  constructor(
    private fb: FormBuilder,
    private apiPayloadService: ApiPayloadService,
    private apiCallService: ApiCallService,
    private router: Router,
    // @Inject(LoaderService) private loaderService: LoaderService,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private handleErrror: ErrorhandlingService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private cookieService: CookieService,
    private viewPortScroller: ViewportScroller,
    private notificationService: NotificationService,
     private DeviceIdService: DeviceIdService,
    private musicService: MusicService,
    @Inject(PLATFORM_ID) private platformId: object,
    private route: ActivatedRoute
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.window = this.isBrowser ? window : null;

    // this.openPopup();
  }

  ngOnInit(): void {

  //   if (isPlatformBrowser(this.platformId)) {
  //   this.route.queryParamMap.subscribe(params => {
  //     const referralCode = params.get('refral');
  //     if (referralCode) {
  //       sessionStorage.setItem('referralCode', referralCode);
  //     }
  //   });
  // }
  if (isPlatformBrowser(this.platformId)) {
  this.route.queryParamMap.subscribe(params => {
    // Check for referral code
    const referralCode = params.get('refral');
    if (referralCode) {
      sessionStorage.setItem('referralCode', referralCode);
    }

    // Check for ad code (pixel code)
    const adCode = params.get('ad');
    if (adCode) {
      sessionStorage.setItem('adCode', adCode); 
    }
  });
}
    //    this.loaderService.show(); // Show loader immediately
    // setTimeout(() => {
    //   this.loaderService.hide(); // Hide loader after 2 seconds
    // }, 1000);
    this.initForm();
    register(); // Initialize Swiper
  }
  isBrowser: boolean;
  ngAfterViewInit(): void {
    // Swiper is handled automatically; no additional logic needed
  }

  private initForm(): void {
  let storedReferral = '';
  let storedAdCode = '';

  if (isPlatformBrowser(this.platformId)) {
    storedReferral = sessionStorage.getItem('referralCode') || '';
    storedAdCode = sessionStorage.getItem('adCode') || '';
  }

  this.signupForm = this.fb.group(
    {
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      username: ['', Validators.required],
      referralCode: [storedReferral],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, passwordValidator()]],
      confirmPassword: ['', Validators.required],
      // dobDay: ['', Validators.required],
      // dobMonth: ['', Validators.required],
      // dobYear: ['', Validators.required],
      // gender: ['', Validators.required]
    },
    { validators: passwordMatchValidator() }
  );
}



  checkPasswordStrength(): void {
    const password = this.signupForm.get('password')?.value || '';

    this.passwordChecks.length = password.length >= 8;
    this.passwordChecks.numbers = (password.match(/[0-9]/g) || []).length >= 2;
    this.passwordChecks.uppercase = /[A-Z]/.test(password);
    this.passwordChecks.lowercase = /[a-z]/.test(password);
    this.passwordChecks.special = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (this.allRequirementsMet()) {
      const lengthScore = Math.min((password.length - 8) * 5, 30);
      const numbersScore = Math.min(
        (password.match(/[0-9]/g) || []).length * 10,
        20
      );
      const specialScore = Math.min(
        (password.match(/[!@#$%^&*(),.?":{}|<>]/g) || []).length * 10,
        20
      );
      const uppercaseScore = Math.min(
        (password.match(/[A-Z]/g) || []).length * 10,
        15
      );
      const lowercaseScore = Math.min(
        (password.match(/[a-z]/g) || []).length * 10,
        15
      );

      this.passwordStrength = Math.min(
        lengthScore +
          numbersScore +
          specialScore +
          uppercaseScore +
          lowercaseScore,
        100
      );
      // if requirements are met, clear the submit-error flag
      this.showPasswordErrorsOnSubmit = false;
    } else {
      this.passwordStrength = 0;
    }
  }

  allRequirementsMet(): boolean {
    return Object.values(this.passwordChecks).every((check) => check);
  }

  getPasswordStrengthText(): string {
    if (this.passwordStrength < 40) return 'Weak';
    if (this.passwordStrength < 70) return 'Medium';
    return 'Strong';
  }

  togglePassword(): void {
    this.showpassword = !this.showpassword;
  }

  toggleConfirmPassword(): void {
    this.Confirmshowpassword = !this.Confirmshowpassword;
  }

 async createUser(): Promise<void> {
    setTimeout(() => {
      this.scrollToTop();
    }, 500);

    if (this.signupForm.invalid) {
      // show password errors after user attempts to submit
      this.showPasswordErrorsOnSubmit = true;
      // Mark all controls as touched to show validation errors
      this.signupForm.markAllAsTouched();
      return;
    }

    const resolvedDeviceId = await this.DeviceIdService.getDeviceId();
    const resolvedFingerprint = await this.DeviceIdService.getDeviceFingerprint(); 

    
  const userData: Partial<CreateUser> = {
  ...this.signupForm.value,
  DeviceId: resolvedDeviceId,
  DeviceFingerprint: resolvedFingerprint || ''
};
      // Create payload
  const payload = this.apiPayloadService.createCreateUserPayload(userData);

  this.loaderService.show();

  this.apiCallService
    .PostCallWithoutToken(payload, 'User/CreateUser')
      .subscribe({
      next: (response) => {
  console.log('API Success', response);

  this.loaderService.hide();

  if (response?.responseCode === 200) {

    console.log('Opening Popup');

    const dialogRef = this.openPopup();

    console.log(dialogRef);

    dialogRef.afterClosed().subscribe(() => {
      console.log('Popup Closed');
      this.router.navigate(['/login']);
    });

  } else {
    this.handleErrror.handleResponseError(response);
  }
}
      });
  }
  openPopup(
    isGoogleLogin: boolean = false
  ): MatDialogRef<SignUpPopUpComponent> {
    const email = this.signupForm?.get('email')?.value;
    const dialogRef = this.dialog?.open(SignUpPopUpComponent, {
      width: '400px',
      disableClose: true,
      data: { email, isGoogleLogin },
    });

    // Hide overflow on body to prevent scrolling issues
    if (this.window) {
      this.window.document.body.style.overflow = 'hidden';
    }

    setTimeout(() => this.cdr.detectChanges()); // Ensure UI updates

    dialogRef.afterClosed().subscribe(() => {
      if (this.window) {
        this.window.document.body.style.overflow = ''; // Restore overflow
      }
    });

    return dialogRef;
  }

  restrictWhiteSpaces(): void {
    //
    const usernameControl = this.signupForm.get('username');
    const usernameValue = usernameControl?.value || '';

    if (/\s/.test(usernameValue)) {
      //
      this.toastr.error('Username cannot contain white spaces.');
      usernameControl?.setValue(usernameValue.replace(/\s/g, ''));
    }
  }

  closeSignup(): void {
    if (this.isPopup) {
      this.closed.emit();
    } else {
      this.router.navigate(['/']);
    }
  }

  openLoginPopup(event: Event): void {
    event.preventDefault();
    if (this.isPopup) {
      this.switchToLogin.emit();
    } else {
      this.router.navigate(['/login']);
    }
  }

  trackByFn(index: number, slide: Slide): string {
    return `${slide.id}-${index}`;
  }
  isScreenWidthLessThan800(): boolean {
    return window.innerWidth < 800;
  }

  scrollToTop() {
    const element = document.getElementById('formContainer');
    if (element) {
      element.scrollTop = 0;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  continueWithGoogle() {
    const clientId =
      '996395306309-6amafcbh3p6faflbmhgmfa4ish1vt3b6.apps.googleusercontent.com';
  const redirectUri = 'https://highrollers.game/login';
    const responseType = 'id_token';
    const scope = 'openid email profile';
    const nonce = this.generateNonce();

    const googleOAuthUrl =
      `https://accounts.google.com/o/oauth2/v2/auth` +
      `?client_id=${clientId}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_type=${responseType}` +
      `&scope=${encodeURIComponent(scope)}` +
      `&nonce=${nonce}`;

    // Show loader briefly before redirecting so user sees feedback
    try {
      this.loaderService.show();
    } catch (e) {
      // ignore if loader service isn't available
    }
    setTimeout(() => {
      try {
        this.loaderService.hide();
      } catch (e) {
        // ignore
      }
      window.location.href = googleOAuthUrl;
    }, 1000);
  }

  generateNonce() {
    return Math.random().toString(36).substring(2);
  }

 async VerfiyGoogleUser(token: string) {
  this.loaderService.show();

  const referralCode = sessionStorage.getItem('refCode');
  const adCode = sessionStorage.getItem('adCode');

  const deviceId = await this.DeviceIdService.getDeviceId();
  const deviceFingerprint = await this.DeviceIdService.getDeviceFingerprint();

  let apiUrl =
    `User/ContinueWithGoogle?idToken=${encodeURIComponent(token)}` +
    `&DeviceId=${encodeURIComponent(deviceId)}` +
    `&DeviceFingerprint=${encodeURIComponent(deviceFingerprint)}`;

  if (referralCode) {
    apiUrl += `&RefferCode=${encodeURIComponent(referralCode)}`;
  }

  if (adCode) {
    apiUrl += `&ad=${encodeURIComponent(adCode)}`;
  }

  this.apiCallService
    .PostCallWithoutToken(null, apiUrl)
    .subscribe(
      (response) => {
        if (response.responseCode == 200) {
          const dialogRef = this.openPopup(true);
          dialogRef.afterClosed().subscribe(() => {});
          this.loaderService.hide();
        } else {
          this.handleErrror.handleResponseError(response);
          this.loaderService.hide();
        }
      },
      (error) => {
        this.loaderService.hide();
        this.handleErrror.handleHttpError(error);
      }
    );
}

  // Play Stop Music

  startMusicOnce = () => {
    this.startMusic();
    this.removeInteractionListeners();
  };

  removeInteractionListeners() {
    document.removeEventListener('mousemove', this.startMusicOnce);
    document.removeEventListener('scroll', this.startMusicOnce);
    document.removeEventListener('click', this.startMusicOnce);
  }

  ngOnDestroy() {
    this.removeInteractionListeners();
  }

  startMusic() {
    this.musicService.playMusic();
  }

  toggleMusic() {
    this.musicService.muteUnmute();
  }

  get isMusicMuted(): boolean {
    return this.musicService.isMusicMuted();
  }
}
